var ForgotPassword = function(){

	var validation = new Validation();

	function init(){

	}; 

	$('[data-page="esqueci-senha"] .btn-forgot-password').on('click', function(e){
		e.preventDefault()

		var form = $('.form-forgot-password');

		if($(this).hasClass('btn-purple'))
		{
			form.submit();
		}
	})	

	$('.form-forgot-password .form-control').on('keyup', function(){
		validationFormForgotPass($(this));
	});

	// $(".form-forgot-password").on('submit', function(e) {
	// 	e.preventDefault();
    //     var form = $(this);
    //     TweenMax.fromTo($('.load'), 0.5, {css:{alpha:0,display:'block'}}, {css:{alpha:1}, ease:Power1.easeOut});
    //     $.ajax({
	// 		// url: AjaxPath.EsqueciSenha,
	// 		url: '/website/public/password/email',
	// 		type: 'POST',
	// 		data: form.serialize(),
	// 		dataType: 'json',
	// 		success: function (result) {
	// 		    if (result != null) { 
	// 		        if(result.Sucesso)
	// 		        {
    //                     location.href = result.Mensagem;
	// 		        }
	// 		        else
	// 		        {
    //                     alert('Erro!',result.Mensagem);
	// 		        }
	// 		    }

	// 		    TweenMax.fromTo($('.load'), 0.5, {css:{alpha:1,display:'none'}}, {css:{alpha:1}, ease:Power1.easeOut});
	// 		},
	// 		error: function (XMLHttpRequest, textStatus, errorThrown) {
	// 		    console.log("Erro")
	// 		    TweenMax.fromTo($('.load'), 0.5, {css:{alpha:1,display:'none'}}, {css:{alpha:0}, ease:Power1.easeOut});
	// 		}
	// 	});
	// });

	function validationFormForgotPass(input)
	{

		var error = false;
    	var form = $('.form-forgot-password');

    	var email = form.find('[id="lost-pass-email"]');

    	if (!validation.IsEmail(email.val()) || validation.isNull(email.val())) {
    		error = true;
    		if($(email).attr('id') == $(input).attr('id')){
    			email.addClass('error');
    		}
    	} else {
			email.removeClass('error');
    	}  	

    	if(!error)
    	{		
    		$('.btn-forgot-password').addClass('btn-purple');
    		$('.btn-forgot-password').removeClass('btn-register');
    	} 
    	else
    	{
    		$('.btn-forgot-password').addClass('btn-register');
    		$('.btn-forgot-password').removeClass('btn-purple');
    	}   	  	
	};	
  
	return init();
};